<template>
  <div class="p-6">
    <h2 class="text-xl font-semibold mb-4">Listado de Roles</h2>

    <div class="dis-div">
      <v-row justify="start">
        <v-btn
          color="success"
          @click="openCreateModal"
          class="ml-3 border-button"
        >
          Crear Rol
          <v-icon class="ml-2">mdi-plus-box-multiple-outline</v-icon>
        </v-btn>
      </v-row>
      <v-row justify="end">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          hide-details
          label="Buscar rol"
          single-line
          class="r-search"
        />
      </v-row>
    </div>

    <!-- Tabla -->
    <v-data-table
      :headers="headers"
      :items="roles"
      :search="search"
      :loading="loading"
      loading-text="Cargando roles..."
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.permissions`]="{ item }">
        <v-dialog max-width="1000" transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="rgb(204 33 40)"
              class="white--text border-button mr-2"
              style="cursor: pointer"
              v-bind="attrs"
              v-on="on"
            >
              Ver Permisos
              <v-icon class="ml-2">mdi mdi-server-security</v-icon>
            </v-btn>
          </template>
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                dark
                style="
                  background-color: rgb(204 33 40);
                  color: white !important;
                "
              >
                Permisos Asociados Al Rol [{{
                  item.name
                }}]

                <v-icon
                  style="margin-left: auto !important"
                  @click="dialog.value = false"
                  >mdi-close
                </v-icon>
              </v-toolbar>

              <div class="permiso-cell">
                <v-chip
                  v-for="r in item.permissions"
                  :key="r"
                  :color="getRandomColor(r.name)"
                  medium
                  class="ma-1"
                >
                  {{ r.name }}
                </v-chip>
              </div>
            </v-card>
          </template>
        </v-dialog>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          color="rgb(204 33 40)"
          class="white--text border-button"
          @click="editRole(item)"
        >
          Editar
          <v-icon class="ml-2">mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Modal Crear Rol -->
    <v-dialog v-model="showModal" max-width="900px" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ isEditing ? "Editar Rol" : "Crear Rol" }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-text-field
              v-model="form.name"
              label="Nombre del Rol"
              :rules="inputRules"
              required
            />
            <v-text-field
              v-model="form.description"
              label="Descripción"
              :rules="inputRules"
              required
            />
          </v-form>
          <v-row justify="center">
            <v-col cols="12" sm="6">
              <v-alert
                v-if="showAlert"
                :type="alertType"
                dense
                outlined
                border="left"
                colored-border
                class="my-4"
              >
                {{ alertMessage }}
              </v-alert>
            </v-col>
          </v-row>
          <div class="dis-div mt-3">
            <v-row justify="start" class="ml-1">
              <p class="c-black">Permisos Disponibles</p>
            </v-row>
            <v-row justify="end" class="mr-1">
              <v-text-field
                v-model="searchModal"
                append-icon="mdi-magnify"
                hide-details
                label="Buscar Permiso"
                single-line
                class="r-search"
              />
            </v-row>
          </div>

          <v-row class="permiso-lista mt-3" justify="start">
            <v-col
              v-for="p in filteredPermissions"
              :key="p.name"
              cols="12"
              sm="6"
              md="6"
            >
              <v-card class="permiso-card" elevation="3">
                <v-card-text class="d-flex align-center bcard">
                  <v-checkbox
                    v-model="selectedPermissions"
                    :value="p"
                    hide-details
                    class=""
                    style="margin-top: inherit"
                    color="rgb(204 33 40)"
                  ></v-checkbox>
                  <div class="div-b-c">
                    <span>{{ p.name }}</span>
                    <p class="tam-p">{{ p.description }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" text @click="closeModal">Cancelar</v-btn>
          <v-btn
            style="background-color: rgb(204 33 40); color: white !important"
            @click="saveRole"
            :disabled="!formValid"
          >
            {{ isEditing ? "Guardar Cambios" : "Crear" }}
          </v-btn>
        </v-card-actions>
        <v-overlay :value="loading" absolute opacity="0.6">
          <v-progress-circular
            indeterminate
            size="64"
            color="rgb(204 33 40)"
          ></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";
export default {
  name: "RolesList",
  data() {
    return {
      search: "",
      searchModal: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nombre del Rol", value: "name", width: "12%" },
        { text: "Descripción", value: "description" },
        { text: "Permisos Asociados", value: "permissions" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      roles: [],
      availablePermissions: [],
      selectedPermissions: [],
      showModal: false,
      inputRules: [(v) => !!v || "Campo requerido"],
      formValid: false,
      form: {
        id: 0,
        name: "",
        description: "",
      },
      isEditing: false,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
    };
  },
  mounted() {
    this.fetchRoles();
    this.fetchPermissions();
  },
  computed: {
    filteredPermissions() {
      if (!this.searchModal) return this.availablePermissions;
      const term = this.searchModal.toLowerCase();

      return this.availablePermissions.filter(
        (p) =>
          p.name.toLowerCase().includes(term) ||
          p.description.toLowerCase().includes(term)
      );
    },
  },
  methods: {
    async fetchRoles() {
      try {
        this.loading = true;
        const response = await axios.get(
          environment.HIOPOSWEBSERVICESCOMBINED + "/api/getRoles/2"
        );
        this.roles = response.data.data;
      } catch (error) {
        console.error("Error al obtener roles:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchPermissions() {
      try {
        const response = await axios.get(
          environment.HIOPOSWEBSERVICESCOMBINED + "/api/getPermissions/2"
        );

        this.availablePermissions = response.data.data;
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      }
    },
    editRole(role) {
      this.isEditing = true;
      this.showModal = true;
      this.form = {
        id: role.id,
        name: role.name,
        description: role.description,
      };
      // Si tuvieras los permisos asociados:
      this.selectedPermissions = role.permissions.map((p) => {
        return (
          this.availablePermissions.find((ap) => ap.name === p.name) || {
            name: p.name,
            description: p.description,
          }
        );
      });
    },
    async saveRole() {
      this.loading = true;
      try {
        if (this.isEditing) {
          let editRole = {
            ...this.form,
            permissions: this.selectedPermissions.map((p) => p.name),
            country: 2,
          };
          console.log("Rol actualizado:", editRole);
          const response = await axios.post(
            `${environment.HIOPOSWEBSERVICESCOMBINED}/api/editRole`,
            {
              role: editRole,
              country: 2,
            }
          );
          if (response.data.error) {
            this.setAlert("error", response.data.message);
          } else {
            this.closeModal();
            await this.fetchRoles();
          }
        } else {
          // Crea un nuevo rol
          const newRole = {
            country: 2,
            name: this.form.name,
            description: this.form.description,
            permissions: this.selectedPermissions.map((p) => p.name),
          };
          console.log("Nuevo rol:", newRole);
          const index = this.roles.findIndex((p) => p.name === this.form.name);
          if (index === -1) {
            const response = await axios.post(
              `${environment.HIOPOSWEBSERVICESCOMBINED}/api/saveNewRol`,
              {
                role: newRole,
                country: 2,
              }
            );
            if (response.data.error) {
              this.setAlert("error", response.data.message);
            } else {
              this.closeModal();
              await this.fetchRoles();
            }
          } else {
            this.setAlert(
              "warning",
              "El nombre del rol ya existe, valida si es necesario editarlo."
            );
          }
        }
      } catch (error) {
        console.error("Error guardando rol:", error);
        this.setAlert("error", "Error al guardar el rol.");
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.form = { id: null, name: "", description: "" };
      this.selectedPermissions = [];
      this.isEditing = false;
    },
    getRandomColor(r) {
      const colors = ["gray"];
      const index = Math.abs(this.hashString(r)) % colors.length;
      return colors[index];
    },
    hashString(str) {
      return str.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
    },
    openCreateModal() {
      this.isEditing = false;
      this.showModal = true;
      this.form = { id: null, name: "", description: "" };
      this.selectedPermissions = [];
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
  },
};
</script>

<style scoped>
.r-search {
  max-width: 70%;
  margin-right: 1%;
}
.dis-div {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
.div-b-c {
  display: block !important;
  align-items: center;
}
.c-black {
  font-size: x-large;
}
.permiso-lista {
  max-height: 350px; /* visible ~2 filas completas */
  overflow-y: auto;
  padding-right: 10px;
}

/* Scroll estilizado (opcional) */
.permiso-lista::-webkit-scrollbar {
  width: 6px;
}
.permiso-lista::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Cards con mejor presentación */
.permiso-card {
  border-radius: 12px;
  transition: transform 0.2s ease;
}
.permiso-card:hover {
  transform: scale(1.03);
}
.tam-p {
  font-size: smaller;
}
.bcard {
  border: 1px solid rgb(8, 8, 8);
}
.border-button {
  border-radius: 15px;
}
.permiso-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  padding: 20px;
  max-height: 400px; /* Ajusta según el alto que quieras mostrar */
  overflow-y: auto; /* Scroll vertical si hay muchos permisos */
  overflow-x: hidden;
  border-radius: 6px;
}

/* Scrollbar personalizado */
.permiso-cell::-webkit-scrollbar {
  width: 6px;
}

.permiso-cell::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
